export const SCHEDULE_STATUS_CODES = {
    PUBLISHED: "PUBLISHED",
    PARTIALLY_PUBLISHED: "PARTIALLY_PUBLISHED",
    APPROVED: "APPROVED",
    PENDING_APPROVAL: "PENDING_APPROVAL",
    WITHDRAWN: "WITHDRAWN",
    UNPUBLISHED: "UNPUBLISHED",
}

export const SCHEDULE_LOCK_STATUSES = {
    LOCKED: "LOCKED",
    UNLOCKED: "UNLOCKED",
    DEFAULT: "DEFAULT",
}

export const SCHEDULE_PRESET_CODES = {
    MAIN: "MAIN",
}

export const SCHEDULE_PRESETS_TYPES = {
    [SCHEDULE_PRESET_CODES.MAIN]: {
        id: SCHEDULE_PRESET_CODES.MAIN,
        name: $filter('translate')('Main view')
    },
}